<template>
  <Container
    class="bg-surface-default-low border-static-default-low shadow-short sticky top-0 z-10 w-full"
  >
    <header class="relative flex h-56 text-center">
      <div class="flex grow items-center justify-between">
        <RevButtonIcon
          v-if="hasBack"
          :alternative-text="i18n(translations.back)"
          :icon="IconArrowLeft"
          variant="ghost"
          @click="emit('back')"
        />

        <TheLogo class="m-auto h-16" @click="emit('home')" />

        <RevLink v-if="hasSkip" @click="emit('skip')">
          {{ i18n(translations.skipStep) }}
        </RevLink>
      </div>

      <div
        v-if="hasStepData"
        aria-hidden
        class="border-t-static-default-low absolute bottom-0 h-2 w-full border-t-2"
      >
        <div
          class="border-t-static-default-hi absolute -top-2 left-0 border-t-2 ease-in-out motion-safe:transition-all motion-safe:duration-200"
          :style="progressWidthStyle"
        />
      </div>
    </header>
  </Container>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevLink } from '@ds/components/Link'
import { IconArrowLeft } from '@ds/icons/IconArrowLeft'

import TheLogo from '~/scopes/navigation/components/TheLogo.vue'

import Container from '../Container/Container.vue'

import translations from './Header.translations'

const i18n = useI18n()

export type HeaderProps = {
  activeStepIndex?: number
  stepsCount?: number
  hasBack?: boolean
  hasSkip?: boolean
}

const {
  activeStepIndex = undefined,
  stepsCount = undefined,
  hasBack = false,
  hasSkip = false,
} = defineProps<HeaderProps>()

const emit = defineEmits<{
  (e: 'back'): void
  (e: 'skip'): void
  (e: 'home'): void
}>()

const hasStepData = computed(() => {
  return typeof activeStepIndex === 'number' && typeof stepsCount === 'number'
})

const progressWidthStyle = computed(() => {
  return {
    width:
      typeof activeStepIndex === 'number' && typeof stepsCount === 'number'
        ? `${(100 * (1 + activeStepIndex)) / stepsCount}%`
        : '0',
  }
})
</script>
